module.exports = __webpack_public_path__ + "static/media/Spartan.b1c2a7c8.jpg";